import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { CdkPortal } from '@angular/cdk/portal';
import { AfterViewInit, Component, EventEmitter, inject, OnDestroy, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'cv-spinner-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [
    CdkPortal
  ]
})
export class ModalSpinnerComponent implements AfterViewInit, OnDestroy {
  @ViewChild(CdkPortal) public readonly portal: CdkPortal | undefined;
  @Output() public readonly closeDialog = new EventEmitter<void>();

  private readonly overlay = inject(Overlay);

  private readonly overlayConfig = new OverlayConfig({
    hasBackdrop: true,
    positionStrategy: this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically(),
    scrollStrategy: this.overlay.scrollStrategies.block(),
    panelClass: 'ibk-cv-modal',
    backdropClass: 'ibk-cv-backdrop',
  });
  private overlayRef = this.overlay.create(this.overlayConfig);

  constructor() {
    this.overlayRef.backdropClick().subscribe(() => {
      this.closeDialog.emit();
    });
  }

  public ngAfterViewInit(): void {
    this.overlayRef?.attach(this.portal);
  }

  public ngOnDestroy(): void {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
  }

}
